import React, { useState, useEffect } from "react";
import UserSidebar from "../../Component/UserSidebar";
import { Link, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as userAction from "../../actions/userActions";
import * as baseActions from "../../actions/baseActions";
import { useForm } from "react-hook-form";
import Button from "../../Component/Button";
import { Row, Col, Form } from "react-bootstrap";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}

const DeleteProfile = (props) => {

  const { title, actions, updateProfileData, userInfo, setting } = props;
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = title;
    actions.getUserProfile(userInfo.id);
  }, [title, actions, userInfo]);


  const { register, formState: { errors }, handleSubmit, unregister, reset } = useForm({
    defaultValues: {
      delete_reason: updateProfileData?.delete_reason || "",
      id: updateProfileData?.id || ""
    }
  });

  const [check, setCheck] = useState("yes");
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append(
      "delete_reason",
      check == "no" ? "No Reason" : data.delete_reason
    );
    try {
      const result = await actions.DeleteRequest(formData, updateProfileData.id);

      if (result?.message) {
        setPopupMessage(result.message);
        setShowPopup(true);
      }
      if (result?.success) {
        setIsSuccess(true);
      }
    } catch (err) {
      console.error("Error submitting delete reason:", err);
      setPopupMessage("Something went wrong. Please try again later.");
      setShowPopup(true);
    }
  };

  useEffect(() => {
    if (check === "no") {
      unregister("delete_reason"); // remove validation when not needed
    }
  }, [check, unregister]);

  const handlePopupClose = () => {
    setShowPopup(false);

    if (isSuccess) {
      reset({ delete_reason: "" });
      setCheck("yes");
      setIsSuccess(false);
      navigate("/manage-profile");
    }
  };

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h1 className="dash_heading mb-3">Delete Profile</h1>
          <div className="box shadow bg-white p-4">
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <div className="faqouter">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Control
                      type="hidden"
                      {...register("id")}
                    />
                    <Row>
                      <Col md={12}>
                        <Row className="align-items-center">
                          <Col sm={9}>
                            <Row>
                              <Col sm={12}>
                                <label htmlFor="delete_reason">
                                  <div dangerouslySetInnerHTML={{
                                    __html: setting?.delete_profile_email_content?.replaceAll("\r\n", "<br>") || "",
                                  }}></div>
                                  <br />
                                  <label className="customeValidationText" htmlFor="delete_reason">
                                    (1500 characters) *
                                  </label>
                                </label>
                                <Col sm={12}>
                                  <div className="form-group">
                                    <span className="ml-md-3">
                                      <span className="custom_radio ml-0">
                                        I would you like to give the reason for
                                        deletion &nbsp;{" "}
                                        <input
                                          type="radio"
                                          name="employee"
                                          checked={check === "yes"}
                                          value="yes"
                                          {...register("employee", { required: true })}
                                          onClick={(e) =>
                                            setCheck(e.target.value)
                                          }
                                        />
                                        <span className="radio_indicator">
                                          &nbsp;
                                        </span>
                                      </span>
                                      <span className="custom_radio">
                                        I would not like to give the reason for
                                        the deletion &nbsp;{" "}
                                        <input
                                          type="radio"
                                          name="employee"
                                          checked={check === "no"}
                                          value="no"
                                          {...register("employee", {
                                            required: true,
                                          })}
                                          onClick={(e) =>
                                            setCheck(e.target.value)
                                          }
                                        />
                                        <span className="radio_indicator">
                                          &nbsp;
                                        </span>
                                      </span>
                                    </span>
                                  </div>
                                </Col>
                                {check == "yes" && (
                                  <Form.Control
                                    as="textarea"
                                    className={
                                      errors?.delete_reason
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    aria-invalid={
                                      errors?.delete_reason ? "true" : "false"
                                    }
                                    {...register("delete_reason", {
                                      required: "Please enter delete reason.",
                                      maxLength: {
                                        value: 1500,
                                        message: "Delete reason should not exceed 1500 characters.",
                                      },
                                    })}
                                  />
                                )}
                                {errors?.delete_reason && (
                                  <label className="customeValidationText text-left" htmlFor="delete_reason">
                                    Please enter delete reason
                                  </label>
                                )}
                                {errors?.delete_reason &&
                                  errors?.delete_reason?.type === "maxLength" && (
                                    <label className="customeValidationText text-left" htmlFor="delete_reason">
                                      Delete reason should not more than 1500
                                      characters
                                    </label>
                                  )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={12}>
                        <Row>
                          <Col md={12}>
                            <div className="form-group mt-3 text-left">
                              <Button
                                title={"Submit"}
                                className={"btn w-10 loginsubmit"}
                                type="submit"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <button type="button" className="sidebar_overlay" onClick={SidebarRemoveClass}></button>

      <PopupModalWithOk
        show={showPopup}
        onHide={handlePopupClose}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </div>
  );
};

DeleteProfile.propTypes = {
  title: PropTypes.string.isRequired,
  isAuth: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  isLoad: PropTypes.bool.isRequired,
  isData: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    getUserProfile: PropTypes.func.isRequired,
    DeleteRequest: PropTypes.func.isRequired,
  }).isRequired,
  updateProfileData: PropTypes.shape({
    delete_reason: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  setting: PropTypes.shape({
    delete_profile_email_content: PropTypes.shape({
      replaceAll: PropTypes.func,
    }).isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    isData: state.isData,
    updateProfileData: state.updateProfileData,
    isLoad: state.isLoad,
    userInfo: state.userInfo,
    isAuth: state.isAuth,
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userAction, ...baseActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProfile);
